var Cross = require("./cross.svg").default;
var EyeOpened = require("./eyeOpened.svg").default;
var EyeClosed = require("./eyeClosed.svg").default;
var Search = require("./search.svg").default;
export var sizes = {
  cross: {
    width: 12,
    height: 12
  },
  eyeClosed: {
    width: 19,
    height: 11
  },
  eyeOpened: {
    width: 19,
    height: 13
  },
  search: {
    width: 16,
    height: 16
  }
};
export { Cross };
export { EyeOpened };
export { EyeClosed };
export { Search };